import * as React from "react";
import { LogoFooter, Mail, Phone } from "../../common/icons";
import { Link } from "react-router-dom";
import { useContext } from "src/ReactTS";
import { AuthContext } from "src/components/context/AuthContext";
import "./index.scss";
import * as moment from "moment";
import { contato, phoneRemoveMask } from "src/util/constants";
import * as BTGLogoFooter from "src/assets/logos/btg_logo_white_footer.png";

const Footer = () => {
  const { currentEmail, currentUser } = useContext(AuthContext);

  return (
    <footer className="decode-footer">
      <div className="decode-footer-sitemap">
        <div className="decode-container">
          {currentEmail && currentUser ? (
            <Link to="/">
              <LogoFooter lighten styles={{ width: "292px", display: "inline-block", verticalAlign: "middle" }} />
            </Link>
          ) : (
            <a href="https://precatoriosbrasil.com/">
              <LogoFooter lighten styles={{ width: "292px", display: "inline-block", verticalAlign: "middle" }} />
            </a>
          )}

          <nav className="decode-footer-nav">
            <ul className="decode-footer-nav-list">
              <li className="decode-footer-nav-item">
                <a href="#">Início</a>
              </li>
              <li className="decode-footer-nav-item">
                <a href="https://precatoriosbrasil.com/sobre">Sobre nós</a>
              </li>
              <li className="decode-footer-nav-item">
                <a href="https://blog.precatoriosbrasil.com" target="_blank">
                  Blog
                </a>
              </li>
            </ul>
            <ul className="decode-footer-nav-list">
              <li className="decode-footer-nav-item decode-footer-nav-button">
                <a href="https://precatoriosbrasil.com/">Consulte seu Precatório</a>
              </li>
              <li className="decode-footer-nav-item">
                <Phone styles={{ width: "20px" }} /> <a href={`tel:${phoneRemoveMask(contato.telefone1)}`}>{contato.telefone1}</a>
              </li>
              <li className="decode-footer-nav-item">
                <Mail styles={{ width: "18px" }} /> <a href={`mailto:${contato.email}`}>{contato.email}</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="decode-footer-copyrights">
        <div className="decode-container decode-container-flex decode-container-flex--spaced">
          <span>Copyright © {moment().year()} BTG Pactual. Todos os direitos reservados</span>
          <a href="https://www.btgpactual.com/" target="_blank">
            <img src={BTGLogoFooter} height="50px" alt="BTG Pactual" />
          </a>
          <ul className="decode-footer-nav-list decode-footer-nav-list-inline">
            <li className="decode-footer-nav-item">
              <a href="https://precatoriosbrasil.com/termos-de-uso">Termos de Uso</a>
            </li>
            <li className="decode-footer-nav-item">
              <a href="https://app.precatoriosbrasil.com/meus-precatorios/termos-e-condicoes-gerais">Termos e Condições Gerais</a>
            </li>
            <li className="decode-footer-nav-item">
              <a href="https://precatoriosbrasil.com/politica-de-privacidade">Política de Privacidade</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/template/footer/index.tsx